// DateUtil.js

export function obtenerPeriodoActual() {
  const fechaActual = new Date();
  const meses = [
    "ENERO",
    "FEBRERO",
    "MARZO",
    "ABRIL",
    "MAYO",
    "JUNIO",
    "JULIO",
    "AGOSTO",
    "SEPTIEMBRE",
    "OCTUBRE",
    "NOVIEMBRE",
    "DICIEMBRE",
  ];
  const mes = meses[fechaActual.getMonth()];
  const año = fechaActual.getFullYear().toString().slice(-2);
  return `${mes}-${año}`;
}

// ---- NUEVO: formateo estándar CL DD-MM-AAAA ----
const pad2 = (n) => String(n).padStart(2, "0");

/**
 * Acepta:
 * - Date
 * - "YYYY-MM-DD"
 * - "YYYY-MM-DDTHH:mm:ss..." (o con Z)
 * - "DD/MM/YYYY" o "DD-MM-YYYY" (lo deja normalizado con "-")
 */
export function formatDateCL(value) {
  if (!value) return "";

  // Date nativo
  if (value instanceof Date && !isNaN(value.getTime())) {
    const dd = pad2(value.getDate());
    const mm = pad2(value.getMonth() + 1);
    const yyyy = value.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
  }

  const s = String(value).trim();

  // ISO date: YYYY-MM-DD
  let m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (m) return `${m[3]}-${m[2]}-${m[1]}`;

  // ISO datetime: YYYY-MM-DDTHH:mm...
  m = s.match(/^(\d{4})-(\d{2})-(\d{2})[T\s].*$/);
  if (m) return `${m[3]}-${m[2]}-${m[1]}`;

  // CL con slash: DD/MM/YYYY
  m = s.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (m) return `${m[1]}-${m[2]}-${m[3]}`;

  // CL con guión: DD-MM-YYYY (ya OK)
  m = s.match(/^(\d{2})-(\d{2})-(\d{4})$/);
  if (m) return s;

  // Si no calza, devuelve tal cual (para no romper)
  return s;
}

/** Si necesitas enviar ISO al backend desde un input CL */
export function parseCLToIso(ddmmyyyy) {
  if (!ddmmyyyy) return null;
  const s = String(ddmmyyyy).trim();
  const m = s.match(/^(\d{2})-(\d{2})-(\d{4})$/);
  if (!m) return null;
  return `${m[3]}-${m[2]}-${m[1]}`;
}
